import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteSingleSelect, renderDateField } from '../../../../components/reduxFields';
import { GetReportUrl, base64Encode, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import Loader from '../../../../img/loader.gif';
import { getPatient, getMasterData } from '../../actions/index';
import history from '../../../../history';
import {getPatientListWithPermission} from '../../actions/index';
import {HasUrlAccess} from '../../actions/index';

const validate = (values) => {
  const errors = {};

  if (!values.patientId) {
    errors.patientId = 'Please select client.';
  }
 
  return errors;
};

class DC_SkillAcquisitionRawData_Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,
      patientId: 0,      
      iframeURL: '',
      isLoading: false,
      random: 0,
      FromDate: new Date().setDate(new Date().getDate() - 7),
      ToDate: new Date(),
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);    
  }

  componentWillMount() {
    this.props.HasUrlAccess('/reports/skill-acquisition-raw-data'); 
    let searchObj = {
      locationIds: '0',
      isActiveCheckRequired: 'YES',
      viewTeamClientsOnly: this.props.viewTeamClientsOnlyPermission,
    };
    this.props.getPatientListWithPermission(searchObj);
  }

  appointmentFilterByDate = (formData) => {
    this.resetIframe();

    let FromDateFormat;
    let ToDateFormat;
    // console.log('formData.legth---', Object.keys(formData).length);
    if (Object.keys(formData).length) {
      FromDateFormat = moment(this.state.FromDate).format('YYYY-MM-DD');
      ToDateFormat = moment(this.state.ToDate).format('YYYY-MM-DD');
    } else {
      let DateFormat = new Date().setDate(new Date().getDate() - 7);
      FromDateFormat = moment(DateFormat).format('YYYY-MM-DD');
      let dateFormat = new Date();
      ToDateFormat = moment(dateFormat).format('YYYY-MM-DD');
    }
    let REPORT_URL  = GetReportUrl(this.props.agencyName);  
    let reportName = base64Encode('DC_SkillAcquisitionRawDataReport');
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "PatientId","Value": "` + this.state.patientId + `"},{"Name": "FromSessionDate","Value": "` + FromDateFormat + `"},{"Name": "ToSessionDate","Value": "` + ToDateFormat + `"},{"Name": "Offset","Value": "` + moment().utcOffset() + `"},{"Name": "ViewTeamClientsOnlyPermissionForReports","Value": "` + this.props.viewTeamClientsOnlyPermission + `"},{"Name": "LoginUserId","Value": "` + this.props.loginUserID + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }

  
  handleChange = (input, selectedRecord) => {
    this.setState({ [input.name]: selectedRecord.value });
    input.onChange(selectedRecord.value);
  }

  onLoadReport = (e) => {
    this.setState({ isLoading: false });
  }

  resetIframe() {
    this.setState({ random: this.state.random + 1 });
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }
  onBackClick = () => {
    history.push('/reports/clinical-reports');
  }
  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Clinical {' > '} Skill Acquisition Raw Data Report</h2>
        :
          <h2 className="page_title">Skill Acquisition Raw Data Report</h2>
        }        
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>}
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                <div className="col-sm-4 require mt-35">
                  <Field
                    name="patientId"
                    label="Select Client"
                    handleNewRequest={this.handleChange}
                    options={this.props.patientlist}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className="col-sm-4 require">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4 require">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    // minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
              </div>            
              <div className="row">
                <div className="col-sm-3 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Iframe url={this.state.iframeURL}
          // width="450px"
          height="580px"
          id="myId"
          className="manual_report"
          display="initial"
          position="relative"
          onLoad={(e) => this.onLoadReport(e)}
          key={this.state.random}
          allowFullScreen />
      </div>
    );
  }
}

DC_SkillAcquisitionRawData_Report = reduxForm({
  form: 'DC_SkillAcquisitionRawData_ReportForm',
  validate,
  enableReinitialize: true,
})(DC_SkillAcquisitionRawData_Report);

function mapStateToProps(state) {
  let patients = [];
  if (state.report.patientList && state.report.patientList.data) {
    patients = state.report.patientList.data.patients;
  }
  // console.log('state.report.master_data............',state.report.master_data.allStaffs)

   
  // Start For Role Permission

 let userScreenPermission = [];
 if (state.login.userPermission) {
   let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
   userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
 }

 let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
 let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission && userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0] ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0].permission : false;


 // End For Role Permission

  return {
    orgID: state.login.loginUserInfo.organizationID,
    patientlist: patients,    
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,
    loginUserID: (state.login.loginUserInfo && state.login.loginUserInfo.userID) || null,
  };
}
export default connect(mapStateToProps, { getPatientListWithPermission, HasUrlAccess, getMasterData })(DC_SkillAcquisitionRawData_Report);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/ClinicalReports/DC_SkillAcquisitionRawData_Report.js